export const GadgetProduct = (model: IGadgetsProduct): IGadgetsProductModel => {
	const {
		name,
		name_trans,
		is_active,
		has_variants,
		category_id,
		category,
		partner_id,
		partner,
		loyalty_level_id,
		shipping_method,
		point_price,
		is_manual_gadget_point_price,
		marketing_description,
		producer_trade_name,
		producer_full_name,
		producer_address,
		producer_contact_email,
		main_image,
		variants,
		created_at,
		updated_at,
		...rest
	} = model

	return {
		...rest,
		name: safeLangContentMapper(name),
		nameTrans: name_trans,
		isActive: is_active,
		hasVariants: has_variants,
		categoryId: category_id,
		category: category ? GadgetsCategoryFilterDetails(category) : null,
		partnerId: partner_id,
		partner: partner ? GadgetsPartner(partner) : null,
		loyaltyLevelId: loyalty_level_id,
		shippingMethod: shipping_method,
		pointPrice: point_price,
		isManualGadgetPointPrice: is_manual_gadget_point_price,
		marketingDescription: marketing_description,
		producerTradeName: producer_trade_name,
		producerFullName: producer_full_name,
		producerAddress: producer_address,
		producerContactEmail: producer_contact_email,
		mainImage: main_image ? Media(main_image) : null,
		variants: variants ? variants.map(GadgetsProductVariant) : [],
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const GadgetsProductDetails = (model: IGadgetsProductDetails): IGadgetsProductDetailsModel => {
	const { media, variant_options, videos } = model

	const base = GadgetProduct(model)

	return {
		...base,
		videos,
		media: media ? media.map(Media) : null,
		variantOptions: variant_options ? variant_options.map(GadgetsProductVariantOption) : [],
	}
}

const HTML_NBSP_UNICODE = /\u00A0/g
const HTML_ENTITY_NBSP = /&nbsp;/gi
const HTML_ENTITY_DEC_160 = /&#0*160;/g
const HTML_ENTITY_HEX_A0 = /&#x0*A0;/gi

function htmlNbspToSpace(html: string) {
	return html
		.replace(HTML_NBSP_UNICODE, ' ')
		.replace(HTML_ENTITY_NBSP, ' ')
		.replace(HTML_ENTITY_DEC_160, ' ')
		.replace(HTML_ENTITY_HEX_A0, ' ')
}

const GadgetsProductCommonPayload = (
	event: IFormSubmitEvent<IGadgetsProductDetailsFormValues>,
	other: IGadgetsProductDetailsOther,
): IGadgetsProductCommonPayload => {
	const {
		name,
		ean,
		isActive,
		isVariantsEnabled,
		categoryId,
		loyaltyLevelId,
		partnerId,
		pricePerUnit,
		pointsPerUnit,
		shippingMethod,
		producerTradeName,
		producerFullName,
		producerAddress,
		producerEmail,
		description,
		width,
		length,
		height,
		volume,
		weight,
		material,
	} = event.values
	const { videos, isPointsPerUnitManual, isShowProducerInfo } = other

	const names = {
		pl: name,
	}

	const nameArray = generateLangContentArrayFromObject(names)

	return {
		width,
		length,
		height,
		volume,
		weight,
		material,
		videos,
		name: nameArray,
		ean: isVariantsEnabled ? null : ean,
		is_active: isVariantsEnabled ? false : isActive,
		has_variants: isVariantsEnabled,
		category_id: categoryId,
		loyalty_level_id: loyaltyLevelId,
		partner_id: partnerId,
		price: PriceToPayload(pricePerUnit),
		point_price: isPointsPerUnitManual ? PriceToPayload(pointsPerUnit) : null,
		is_manual_gadget_point_price: isPointsPerUnitManual,
		shipping_method: shippingMethod,
		producer_trade_name: isShowProducerInfo ? producerTradeName : null,
		producer_full_name: isShowProducerInfo ? producerFullName : null,
		producer_address: isShowProducerInfo ? producerAddress : null,
		producer_contact_email: isShowProducerInfo ? producerEmail : null,
		marketing_description: htmlNbspToSpace(description),
		main_image_media_id: null,
	}
}

export const GadgetsProductUpdateToPayload = (
	updated: IGadgetsProductModel,
	event: IFormSubmitEvent<IGadgetsProductDetailsFormValues>,
	other: IGadgetsProductDetailsOther,
): IGadgetsProductUpdatePayload => {
	const payload = GadgetsProductCommonPayload(event, other)

	return {
		...payload,
		id: updated.id,
	}
}

export const GadgetsProductCreateToPayload = (
	event: IFormSubmitEvent<IGadgetsProductDetailsFormValues>,
	other: IGadgetsProductDetailsOther,
): IGadgetsProductCreatePayload => GadgetsProductCommonPayload(event, other)

export const GadgetsProductUpdateStatusBulkToPayload = (
	ids: number[] | string[],
	isActive: boolean,
): IGadgetsProductUpdateStatusBulkPayload => {
	const payloadIds: number[] = ids.map(Number).filter((id): id is number => id !== undefined && !Number.isNaN(id))

	return {
		gadget_ids: payloadIds,
		is_active: isActive,
	}
}

export const GadgetsProductDeleteBulkToPayload = (ids: number[] | string[]): IGadgetsProductDeleteBulkPayload => {
	const payloadIds: number[] = ids.map(Number).filter((id): id is number => id !== undefined && !Number.isNaN(id))

	return {
		gadget_ids: payloadIds,
	}
}
